import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../../theme/Colors.es.js';
import '../../../../theme/Shadows.es.js';
import '../../../../theme/Typography.es.js';
import 'react';
import { LegacyColorMap } from '../../../../theme/LegacyColorMap.es.js';
import '../../SubscriptionForm/SubscriptionForm.es.js';
import { SubscriptionFormWithDisclaimer } from '../../SubscriptionForm/SubscriptionFormWithDisclaimer.es.js';
import '../../SubscriptionForm/DisclaimerText.es.js';
import { Button } from '../../../navigation/Button/Button.es.js';
import { DarkBackgroundButton } from '../../../navigation/DarkBackgroundButton/DarkBackgroundButton.es.js';
import { CTATextContent } from '../CTATextContent.es.js';
import { getBgColor, getCtaBtnColor } from '../utils.es.js';

const Styles = labelStyles("CTACentered", {
  root: (backgroundColor) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    background-color: ${Colors[LegacyColorMap[backgroundColor]]};

    @media screen and (min-width: 768px) {
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      padding: 70px 200px;
    }
  `,
  mediaContent: (maxWidth) => css`
    max-width: ${maxWidth}px;
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `
});
const getSubscriptionFormButton = (bgColor, ctaBtnColor) => {
  const btnColor = getCtaBtnColor(bgColor, ctaBtnColor);
  const btnProps = {
    children: "Submit",
    size: "medium",
    type: "submit"
  };
  if (btnColor === "primary-dark")
    return jsx(DarkBackgroundButton, Object.assign({}, btnProps));
  else {
    return jsx(Button, Object.assign({}, btnProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: btnColor === "primary-alt" ? "primary" : btnColor,
      size: "small"
    }));
  }
};
const CTACentered = ({ backgroundColor = "neutral100", ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth = 570, onCtaClick, onCtaKeyDown, subHeading, isSubscriptionForm, subscriptionPlaceholder, onSubscriptionFormSubmit, ctaTarget }) => {
  const bgColor = getBgColor(backgroundColor);
  const isZapierOrange = bgColor === "zapier";
  if (isZapierOrange && isSubscriptionForm) {
    console.error("Do not use the subscription form with the zapier background. The disclaimer text accessibility is poor on the zapier background.");
  }
  return jsx(
    "div",
    { css: Styles.root(bgColor), "data-zds": true },
    jsx(
      "div",
      { css: Styles.mediaContent(maxWidth), "data-zds": true },
      jsx(CTATextContent, { heading, subHeading, description, ctaText: !isSubscriptionForm ? ctaText : void 0, ctaHref: !isSubscriptionForm ? ctaHref : void 0, ctaBtnColor, onCtaClick: !isSubscriptionForm ? onCtaClick : void 0, onCtaKeyDown, bgColor, alignment: "center", ctaTarget })
    ),
    isSubscriptionForm ? jsx(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder || "", renderButton: () => getSubscriptionFormButton(backgroundColor, ctaBtnColor), onSubmit: onSubscriptionFormSubmit, disclaimerTextColor: bgColor === "neutral100" ? "primary" : "secondary", disclaimerTextType: "Body1" }) : null
  );
};

export { CTACentered };
//# sourceMappingURL=CTACentered.es.js.map
